export default __webpack_public_path__ + "static/media/suggestion-chips-watson-actions0.a8edaa45.png";